'use client'

import { resolvePath } from '@/shared/utils/routesUtils'
import Button from '@/shared/v2/shared/components/Button'
import Paragraph from '@/shared/v2/shared/components/Paragraph'
import Title from '@/shared/v2/shared/components/Title'
import { useTranslations } from 'next-intl'
import Link from 'next/link'

export default function NotFoundPage() {
    const t = useTranslations('root')
    return (
        <div
            className="flex flex-col text-center items-center justify-center h-full text-forest w-full gap-3"
            data-testid="__not-found__"
        >
            <Title.TwoXl>{t('components.lost.title')}</Title.TwoXl>
            <Paragraph color="darkGrey">{t('components.lost.description')}</Paragraph>
            <Link href={resolvePath('/')} className="">
                <Button intent="secondary">{t('components.lost.goHome')}</Button>
            </Link>
        </div>
    )
}
